import React, { Component } from "react";
import { connect } from 'react-redux';
import { getOrderBooking } from "redux/actions/report-actions";
import ReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import { Row, Col, Grid } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import { dateFormatMy } from 'helper/helperFunctions';
import Pagination from "../../ThemeComponents/Pagination";
const moment = window.moment;

class OrderBookingPage extends Component {
	constructor(props) {
		super(props);
		this.dateValidator = new ReactValidator();
		this.state = {
			fromDate: '',
			toDate: '',
			pageSize: 10,
			page: 0,
			sorted: '',
			totalRecords: 0
		}
	}
	DateChangeHandler = (value, field) => {
		this.setState({ [field]: value === null ? '' : moment(value).format("YYYY-MM-DD") }, () => {
			if (this.dateValidator.allValid()) {
				// const { fromDate, toDate, page, pageSize, sorted } = this.state;
				// this.props.getReportsCall(1, fromDate, toDate, page, pageSize, sorted);
				this.pagination.dataCall();
			} else {
				this.dateValidator.showMessages();
				this.forceUpdate();
			}
		})
	}
	dateElement(label, name, value, rules) {
		var selectedDate = this.state[name] !== '' ? new Date(this.state[name]) : '';
		const { fromDate, toDate } = this.state;
		return (
			<div className='form-group fullCalendar' id={name}>
				<label>{label}</label>
				<DatePicker className="form-control calender_icon" selected={selectedDate} name={name} onChange={(event) => this.DateChangeHandler(event, name)} />
				{
					(fromDate !== '' && toDate !== '') &&
					this.dateValidator.message(name, value, rules)
				}
			</div>
		);
	}
	reportsPaginationData = (page = this.state.page, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
		const { fromDate, toDate } = this.state;
		this.props.getReportsCall(1, fromDate, toDate, page, pageSize, sorted);
	}

	paginationCall = (data) => {
		const { fromDate, toDate } = this.state;
		return this.props.getReportsCall(1, fromDate, toDate, data.page, data.pageSize, data.sort)
	}
	render() {
		const { toDate, fromDate } = this.state;
		const { orderBookingData/*, REPORTSpages, loadingOrder */} = this.props;
		const columns = [
			{
				Header: "Report Testing",
				headerClassName: 'headerPagination',
				columns: [

					{
						Header: "Week / Date",
						accessor: "weekNumber",
						Cell: ({ value, original }) => (
							<div>
								{'Week ' + value + ' / ' + dateFormatMy(original.monday)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Estimate Orders To Receive",
						accessor: "count",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "UCD Range",
						accessor: "date",
						Cell: ({ value, original }) => (
							<div>
								{dateFormatMy(original.start) + ' - ' + dateFormatMy(original.end)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},

				]
			}
		];
		return (
			<div className="content">
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<div className="row">
												<Col md={12}>
													<div className="secHeading">Estimate Receiving Report</div>
												</Col>

												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date From', 'fromDate', fromDate !== '' && moment(fromDate, 'YYYY-MM-DD'), [{ before_or_equal: moment(this.state.toDate) }])
															}
														</div>
													</div>
												</Col>
												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date To', 'toDate', toDate !== '' && moment(toDate, 'YYYY-MM-DD'), [{ after_or_equal: moment(this.state.fromDate) }])
															}
														</div>

													</div>
												</Col>
												<Col md={12}>
													<div>Total Records: {orderBookingData?orderBookingData.length : 0}</div>
												</Col>
												{/* <Col md={12} className="mt-md">
													<ReactTable
														noDataText='No report found'
														showPagination={false}
														data={orderBookingData}
														pages={REPORTSpages}
														columns={columns}
														defaultPageSize={10}
														loading={loadingOrder}
														className="-striped listing"
														loadingText={'Loading...'}
														pageData={this.reportsPaginationData}
														manual
														onFetchData={(state, instance) => {

															var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
															state.pageData(state.page + 1, sort, state.pageSize);
														}}
													/>
												</Col> */}
												<Pagination
													ref={(p) => this.pagination = p}
													showPagination={false}
													noDataText='No report found'
													columns={columns}
													pageSize={10}
													getDataCall={this.paginationCall}
													filterView={false}
													// downloadData={true}
													// downloadFileName={'Orders'}
													// lowerContent = {null}
													// filterPlaceHolder = {'Orders'}
													getRowProps={this.getRowProps}
												// showAllToggle={true}
												/>
											</div>
										</Grid>
									</div>
								} />
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		getReportsCall: (value, fromDate, toDate, page, pageSize, sorted) => { return dispatch(getOrderBooking(value, fromDate, toDate, page, pageSize, sorted)) },//example function
	});
};

function mapStateToProps(state) {
	const { orderBookingData, REPORTSpages, REPORTScurrent_page, REPORTStotal_orders, loadingOrder } = state.reportReducer;
	return {
		orderBookingData, REPORTSpages, REPORTScurrent_page, REPORTStotal_orders, loadingOrder
	};
}


const OrderBooking = connect(mapStateToProps, mapDispatchToProps)(OrderBookingPage);
export default OrderBooking;